import { render, staticRenderFns } from "./TransactionTypeConfig.vue?vue&type=template&id=66f65d9a&scoped=true&"
import script from "./TransactionTypeConfig.vue?vue&type=script&lang=js&"
export * from "./TransactionTypeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f65d9a",
  null
  
)

export default component.exports